<template>
   <div class="demo-import2">
        <div v-has='resourceId||""'>
            <el-button :type="type==='text'?'text':(disabled?'defult':'primary')" :disabled="disabled" :icon="icon?icon:''" @click="dialogVisible = true"><slot name="button-name"></slot></el-button>
        </div>
        <el-dialog
        title="导入"
        append-to-body
        :visible.sync="dialogVisible"
        width="50%"
        @close='beforeColse'>
           <el-row>
               <el-col :span="20">
                    <el-upload
                        class='upload-demo'
                        ref="upload"
                        action=''
                        :on-remove='handleRemove'
                        :on-change='onchange'
                        :limit='1'
                        :on-exceed='handleExceed'
                        :file-list='fileList'
                        :show-file-list='true'
                        :auto-upload='false'
                        :http-request="addAttachment"
                        >
                        <el-button type='primary'>选择文件</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="4">
                    <el-button type='primary' @click="submitUpload" :loading='loading'>导 入</el-button>
                </el-col>
           </el-row>
        </el-dialog>
    </div>
</template>
<script>
import request from '@/utils/http';
import { dictWithUrl } from '@/components/lots/api';
export default {
    name: 'mImport',
    data() {
        return {
            fileList: [],
            dialogVisible: false,
            loading: false,
            isLimitSize: true,
            limitSize: null
        };
    },
    props: {
        uploadUrl: String,
        disabled: Boolean,
        type: String,
        icon: String,
        params: Object,
        resourceId: String,
        num: { type: String, default() { return '2'; } }
    },
    computed: {
        myHeader() {
            return {
                'Content-Type': 'multipart/form-data'
            };
        }
    },
    methods: {
        submitUpload() {
            if (this.fileList.length === 0) {
                this.$message.warning('请上传文件');
            } else { this.$refs.upload.submit(); }
        },
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
            );
        },
        handleRemove(row) {
            this.fileList.splice(row, 1);
        },
        onchange(file, fileList) {
            const flag = this.dictData['SRM_IN_OUT_LIMIT_TIME'].SRM_IN_OUT_LIMIT_FLAG;
            this.fileList = fileList;
            if (flag === 'false') {
                const imgSize = Number(file.size / 1024 / 1024);

                if (imgSize > Number(this.dictData['SRM_IN_OUT_LIMIT_TIME'].SRM_IN_OUT_LIMIT_FILE)) {
                    this.$message.warning(`文件大小不能超过${Number(this.dictData['SRM_IN_OUT_LIMIT_TIME'].SRM_IN_OUT_LIMIT_FILE)}MB，请重新上传`);
                    this.fileList = [];
                }
            }
        },
        addAttachment(file) {
            this.loading = true;
            const param = new FormData();
            param.append('file', file.file);
            for (var i in this.params) {
                if (this.params.hasOwnProperty(i)) {
                    if (typeof (this.params[i]) === 'string') {
                        param.append(i, this.params[i]);
                    } else {
                        param.append(i, JSON.stringify(this.params[i]));
                    }
                }
            }
            return request({
                url: this.uploadUrl,
                method: 'post',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: param
            }).then(res => {
                if (res) {
                    if (this.num === 'quoteTemp') { // 导入报价模板
                        // if (res.data.length !== 0) { // 导入有误
                        //     let htmlStr = '';
                        //     res.data.forEach(item => {
                        //         htmlStr += `<div>${item.title}:${item.extStr1}${item.prompt}</div>`;
                        //     });
                        //     this.$message({
                        //         duration: 0,
                        //         dangerouslyUseHTMLString: true,
                        //         showClose: true,
                        //         message: htmlStr,
                        //         type: 'error'
                        //     });
                        //     this.dialogVisible = false;
                        // } else {
                        //     this.$message.success('数据已经在后台导入，请稍后留意消息提醒或邮件通知');
                        //     this.$emit('import-callback', true);
                        //     this.dialogVisible = false;
                        // }
                        this.$message.success(res.data || '数据已经在后台导入，请稍后留意消息提醒或邮件通知');
                        this.$emit('import-callback', true);
                        this.dialogVisible = false;
                    }
                    if (this.num === '2') { // 导入拦标价
                        this.$message.success('文件导入成功！');
                        this.$emit('import-callback', true);
                        this.dialogVisible = false;
                    }
                    if (this.num === '3') { // 导入价格表
                        this.$message.success('数据已经在后台导入，请稍后留意消息提醒或邮件通知');
                        this.$emit('import-callback', true);
                        this.dialogVisible = false;
                    }
                } else {
                    this.$emit('import-callback', false);
                    this.$refs.upload.clearFiles();
                }
            }).finally(() => { this.loading = false; });
        },
        beforeColse() {
            this.fileList = [];
        }
    },
    mounted() {
        dictWithUrl('REPORT_LCP_DC_LINE,REPORT_LCP_DC_PLACE,SRM_IN_OUT_LIMIT_TIME').then(item => {
            this.dictData = item.data;
        });
    },
    components: {}
};
</script>
<style lang='less'>
    .demo-import2 {
        display: inline-block;
        .upload-demo {
            margin-bottom: 10px;
            display: inline-block;
            margin-right: 10px;
        }
        .el-progress {
            display: inline-block;
            width: 200px;
        }
        .el-upload__input {
            display: none;
        }
        h1 {
            font-size: 1.5em
        }
        .el-table th, .el-table td {
            text-align: center
        }
        .el-table {
            min-height: 200px !important;
            max-height: 200px !important;
        }
        .el-upload-list {
            display: inline-block;
        }
        .el-button--primary {
            margin: 0 10px;
        }
        .el-upload-list__item {
            line-height: 1;
            margin-top: 0;
        }
        .el-upload-list__item .el-icon-close {
            top: 0;
        }
    }
    .demo-import2 + .el-button {
        margin-left: 10px;
    }
    .el-button + .demo-import2 {
        margin-left: 10px;
    }
</style>